import { RichText } from "@client/components/RichText";
import React from "react";
import {
    Checkbox as BaseCheckbox,
    CheckboxGroup as BaseCheckboxGroup,
    CheckboxGroupProps,
    CheckboxProps,
    Label,
    Text,
    composeRenderProps,
} from "react-aria-components";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Svg } from "../../Svg";
import { CommonFieldProps, FieldError } from "./utils";

import styles from "./inputs.module.scss";

export function Checkbox({
    children,
    className,
    ...props
}: Omit<CheckboxProps, "className"> & { className?: string }) {
    return (
        <BaseCheckbox
            {...props}
            className={concatClassNames([className, styles.boxWrapper])}
        >
            {composeRenderProps(children, (children, renderProps) => (
                <>
                    <span
                        className={styles.checkbox}
                        data-focus-visible={
                            renderProps.isFocusVisible || undefined
                        }
                    >
                        {renderProps.isSelected && (
                            <Svg aria-hidden name="check" />
                        )}
                    </span>
                    <Label>{children}</Label>
                </>
            ))}
        </BaseCheckbox>
    );
}

export function CheckboxGroup({
    label,
    description,
    errorMessage,
    children,
    className,
    ...props
}: Partial<CommonFieldProps> & Omit<CheckboxGroupProps, "className">) {
    return (
        <BaseCheckboxGroup
            {...props}
            className={concatClassNames([styles.checkboxGroup, className])}
        >
            {composeRenderProps(children, (children) => (
                <>
                    {description && (
                        <Text slot="description">
                            <RichText value={description} />
                        </Text>
                    )}
                    {label && <Label>{label}</Label>}
                    {children}
                    <FieldError>{errorMessage}</FieldError>
                </>
            ))}
        </BaseCheckboxGroup>
    );
}
